var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
let PayTypeOverTimeModel = class PayTypeOverTimeModel {
    constructor() {
        this.start_date = '';
        this.pay_type = PayTypes.NONE;
        this.cost_unit = Units.NONE;
        this.is_active = false;
        this.pay_type_track_mode = PayTypes.NONE;
    }
};
__decorate([
    JsonProperty("start_date", String)
], PayTypeOverTimeModel.prototype, "start_date", void 0);
__decorate([
    JsonProperty("pay_type", String)
], PayTypeOverTimeModel.prototype, "pay_type", void 0);
__decorate([
    JsonProperty("cost_unit", String)
], PayTypeOverTimeModel.prototype, "cost_unit", void 0);
__decorate([
    JsonProperty("is_active", Boolean)
], PayTypeOverTimeModel.prototype, "is_active", void 0);
__decorate([
    JsonProperty("pay_type_track_mode", String)
], PayTypeOverTimeModel.prototype, "pay_type_track_mode", void 0);
PayTypeOverTimeModel = __decorate([
    JsonObject("PayTypeOverTimeModel")
], PayTypeOverTimeModel);
export { PayTypeOverTimeModel };
let PayTypesOverTimeModel = class PayTypesOverTimeModel {
    constructor() {
        this.salaried_weekly_overtime = [];
        this.weighted_shift_weekly_overtime = [];
    }
};
__decorate([
    JsonProperty("salaried_weekly_overtime", [PayTypeOverTimeModel], true)
], PayTypesOverTimeModel.prototype, "salaried_weekly_overtime", void 0);
__decorate([
    JsonProperty("weighted_shift_weekly_overtime", [PayTypeOverTimeModel], true)
], PayTypesOverTimeModel.prototype, "weighted_shift_weekly_overtime", void 0);
PayTypesOverTimeModel = __decorate([
    JsonObject("PayTypesOverTimeModel")
], PayTypesOverTimeModel);
export { PayTypesOverTimeModel };
let OverTimeSettingsModel = class OverTimeSettingsModel {
    constructor() {
        this.pay_types_overtime = [];
    }
};
__decorate([
    JsonProperty("pay_types_overtime", [PayTypesOverTimeModel])
], OverTimeSettingsModel.prototype, "pay_types_overtime", void 0);
OverTimeSettingsModel = __decorate([
    JsonObject("OverTimeSettingsModel")
], OverTimeSettingsModel);
export { OverTimeSettingsModel };
export var PayTypes;
(function (PayTypes) {
    PayTypes["SALARIED"] = "SALARIED";
    PayTypes["WEIGHTED_SHIFT"] = "WEIGHTED_SHIFT";
    PayTypes["NONE"] = "NONE";
    PayTypes["HOURLY"] = "HOURLY";
})(PayTypes || (PayTypes = {}));
export var Units;
(function (Units) {
    Units["HOUR"] = "HOUR";
    Units["SHIFT"] = "SHIFT";
    Units["NONE"] = "NONE";
})(Units || (Units = {}));
//# sourceMappingURL=over-time-settings.model.js.map